import { createAction } from "@reduxjs/toolkit";

export const showVersionMismatch = createAction("app/showVersionMismatch");
